import React, { useEffect } from "react";
import { useState } from "react";
import { Container, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import jsPDF from "jspdf";
import * as htmlToImage from "html-to-image";
import { BsTable } from "react-icons/bs";
import { getAmc } from "../../stores/services/amc.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getReceiptPaymentRegisterReport } from "../../stores/services/report.service";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import { exportToTxt, generateExcel } from "../../utils/customFunction";
import html2pdf from "html2pdf.js";

const RecieptPaymentRegisterReport = () => {
  const contentRef = React.useRef(null);
  const paymentTypeArr = [
    {
      value: "Receipt",
      label: "Receipt",
    },
    {
      value: "Payment",
      label: "Payment",
    },
  ];
  const typeArr = [
    {
      value: "false",
      label: "Posting",
    },
    {
      value: "true",
      label: "Realized",
    },
  ];

  const ColumnHeading = [
    { label: "Ledger ID", value: "Ledger ID" },
    { label: "Txn Type", value: "Txn Type" },
    { label: "Description", value: "Description" },
    { label: "Instruction Date", value: "Instruction Date" },
    { label: "Instrument Date", value: "Instrument Date" },
    { label: "Instrument No", value: "Instrument No" },
    { label: "Instrument Type", value: "Instrument Type" },
    { label: "Bank/Branch", value: "Bank/Branch" },
    { label: "Account Number", value: "Account Number" },
    { label: "Credit Amount", value: "Credit Amount" },
    { label: "Debit Amount", value: "Debit Amount" },
    { label: "Realized", value: "Realized" }
  ]

  const [ColumnArr, setColumnArr] = useState(ColumnHeading)
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: ["Opening Balance", "Closing Balance"]
  })
  const [fontSizeVal, setFontSizeVal] = useState<any>(18)
  const [paperSizeVal, setPaperSizeVal] = useState("A4")
  const [layoutVal, setLayoutVal] = useState("Landscape")
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState()
  const [dimensionOfPages, setDimensionOfPages] = useState<any>()

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState<any>(10)
  const [itemsToShow, setItemsToShow] = useState(10);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  let date = new Date();
  const [allData, setAllData] = useState<any>([]);
  const [allDataCount, setAllDataCount] = useState(0);
  const [allFunds, setAllFunds] = useState<any>([]);
  const [fundCode, setFundCode] = useState("");
  const [fundName, setFundName] = useState("");
  const [type, setType] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [fromDate, setFromDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [screen, setScreen] = useState<any>()

  const [resAmc, setResAmc] = useState("");
  const [resFundName, setResFundName] = useState("");
  const [resPaymentType, setResPaymentType] = useState("");
  const [resFromDate, setResFromDate] = useState(
    moment(date).format("YYYY-MM-DD")
  );
  const [resToDate, setResToDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [isSearchTrue, setIsSearchTrue] = useState(false);

  const [totalDebit, setTotalDebit] = useState<any>(0);
  const [totalCredit, setTotalCredit] = useState<any>(0);

  const getAllAmcFunds = async () => {
    try {
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Request Failed!");
      }
    }
  };

  // useEffect(() => {

  //   getAllAmcFunds();
  // }, []);

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  let txnTypes = useSelector((state: any) => state.txnTypes);
  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const getFunds = async (code: any) => {
    try {
      const response = await getFundByAmc(
        email,
        code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };
  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  //code for search data for Reports

  const searchData = async () => {
    setIsSearchTrue(false)
    setItemsPerPage(10)
    setAllData([])
    try {
      setLoading(true);
      allData.length = 0;
      setAllData(allData);
      setAllDataCount(allData);
      // let fromMonths = new Date(fromDate);
      // let toMonths = new Date(toDate);
      // var premonths;
      // premonths = (toMonths.getFullYear() - fromMonths.getFullYear()) * 12;
      // premonths -= fromMonths.getMonth();
      // premonths += toMonths.getMonth();
      // if(premonths<6){
      const response = await getReceiptPaymentRegisterReport(
        email,
        fundCode,
        paymentType,
        type,
        fromDate,
        toDate
      );
      if (response.data.status == 200) {
        let array = Object.entries(response.data.data);
        setResAmc(amc_name);
        setResFundName(fundName);
        setResPaymentType(paymentType);
        setResFromDate(fromDate);
        setResToDate(toDate);
        let data: any = [];
        array.forEach(([key, value]) => {
          data = value;
          let record = [];
          // record = data.Record;
          record = data;
          record["legder_id"] = data.Key;
          allData.push(record);
        });
        setAllDataCount(allData.length);
        let totaldebit = 0,
          totalcredit = 0;
        allData.map((item: any, index: number) => {
          totaldebit += parseFloat(item.debit_amount);
          totalcredit += parseFloat(item.credit_amount);
        });
        setTotalDebit(totaldebit.toFixed(4));
        setTotalCredit(totalcredit.toFixed(4));
        setLoading(false);
        setIsSearchTrue(true)
        setFontSizeVal(18)
      } else {
        setLoading(false);
        toast.error(response.data.message);
      }
      // }else{
      //   toast.error('You cannot generate report upto 6 months')
      // setLoading(false);
      // }
    } catch (error: any) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message?.toString() ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const numberWithCommas = (amount: any) => {
    return amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  };

  const selectedFund = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fundCode);
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
      }
      : null;
  }, [allFunds, fundCode]);

  const selectedPayment = React.useMemo(() => {
    return paymentType
      ? {
        value: paymentType,
        label: paymentType,
      }
      : null;
  }, [paymentType]);

  const selectedType = React.useMemo(() => {
    const selectedFund = typeArr?.find((item) => item?.value === type);
    return selectedFund
      ? {
        value: selectedFund.value,
        label: selectedFund.label,
      }
      : null;
  }, [typeArr, type]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  useEffect(() => {
    if (allData?.length > 0) {
      let totaldebit = 0,
        totalcredit = 0;
      allData?.slice(0, itemsToShow).map((item: any, index: number) => {
        totaldebit += parseFloat(item.debit_amount);
        totalcredit += parseFloat(item.credit_amount);
      });
      setTotalDebit(totaldebit.toFixed(4));
      setTotalCredit(totalcredit.toFixed(4));
    }
  }, [itemsToShow, allData])


  useEffect(() => {
    const elements = document.querySelectorAll("#test") as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth)
    }

    window.addEventListener("resize", handleScreenResize)
    handleScreenResize()

    return () => {
      window.removeEventListener("resize", handleScreenResize)
    }

  }, [])

  const fixedOrder = [
    "Ledger ID",
    "Txn Type",
    "Description",
    "Instruction Date",
    "Instrument Date",
    "Instrument No",
    "Instrument Type",
    "Bank/Branch",
    "Account Number",
    "Credit Amount",
    "Debit Amount",
    "Realized"
  ];

  const [loadingFileDownload, setLoadingFileDownload] = useState(false)

  const handleDownloadSampleFile = () => {
    setLoadingFileDownload(true)
    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [selectedValues?.sub_heading ? selectedValues?.sub_heading : "", "", "", ""],
      ["Fund", `${resFundName}`, "From Date", `${moment(resFromDate).format("DD-MM-YYYY")}`],
      ["To Date", `${moment(resToDate).format("DD-MM-YYYY")}`, "Report Date", `${moment(date).format("DD-MM-YYYY")}`],
    ];

    const dataSequence = allData?.slice(0, itemsToShow)?.map((item) => {
      return {
        Ledger_ID: item?._id,
        Txn_Type: CapTxnType(item?.txnr_type),
        Description: item.description.split("-")[0],
        Instruction_Date: item?.instruction_date
          ? moment(item.instruction_date).format("DD-MM-YYYY")
          : "-",
        Instrument_Date: item?.instrument_date
          ? moment(item.instrument_date).format("DD-MM-YYYY")
          : "-",
        Instrument_No: item.instrument_no || "-",
        Instrument_Type: item.instrument_type || "-",
        Bank_Branch: `${item.bank_code || ""}-${item.branch || ""}`,
        Account_Number: item.account_number || "-",
        Credit_Amount: numberWithCommas(item.credit_amount),
        Net_Amount: numberWithCommas(item.debit_amount),
        Realized: item.realized === "true" || item.realized === true
          ? "true"
          : "false",
      }
    })

    // dataSequence.push({
    //   Ledger_ID: selectedValues?.columns?.includes("Credit Amount") || selectedValues?.columns?.includes("Debit Amount") ? "Total" : "",
    //   Txn_Type: "",
    //   Description: "",
    //   Instruction_Date: "",
    //   Instrument_Date: "",
    //   Instrument_No: "",
    //   Instrument_Type: "",
    //   Bank_Branch: "",
    //   Account_Number: "",
    //   Credit_Amount: selectedValues?.columns?.includes("Credit Amount") && numberWithCommas(totalCredit),
    //   Net_Amount: selectedValues?.columns?.includes("Debit Amount") && numberWithCommas(totalDebit),
    //   Realized: "",
    // })

    const reorderColumns = (columns, order) => {
      return order.filter(column => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(selectedValues?.columns, fixedOrder);

    const ArrayData = selectedValues?.columns?.length > 0 && dataSequence?.map(entry => {
      const result = {};
      reorderedColumns.forEach(column => {
        if (column === 'Ledger ID') {
          result[column] = entry?.Ledger_ID;
        }
        else if (column === 'Txn Type') {
          result[column] = entry?.Txn_Type;
        }
        else if (column === 'Description') {
          result[column] = entry?.Description;
        }
        else if (column === 'Instruction Date') {
          result[column] = entry?.Instruction_Date;
        }
        else if (column === 'Instrument Date') {
          result[column] = entry?.Instrument_Date;
        }
        else if (column === 'Instrument No') {
          result[column] = entry?.Instrument_No;
        }
        else if (column === 'Instrument Type') {
          result[column] = entry?.Instrument_Type;
        }
        else if (column === 'Bank/Branch') {
          result[column] = entry?.Bank_Branch;
        }
        else if (column === 'Account Number') {
          result[column] = entry?.Account_Number;
        }
        else if (column === 'Credit Amount') {
          result[column] = numberWithCommas(entry?.Credit_Amount);
        }
        else if (column === 'Debit Amount') {
          result[column] = numberWithCommas(entry?.Net_Amount);
        }
        else if (column === 'Realized') {
          result[column] = entry?.Realized;
        }
      });
      return result;

    });

    if (ArrayData.length > 0) {
      const keys = Object.keys(ArrayData[0]); // object get kr rhy taky keys mil sky 
      const firstLast = keys[0]; // first wali key find kri

      // reduce function ky throungh empty object initial ma lia or phr values daal ki 1,2 last or 3 last ma
      const summaryRow = keys.reduce((acc, key) => {
        if (key === firstLast) {
          acc[key] = (selectedValues?.columns?.includes("Credit Amount") || selectedValues?.columns?.includes("Debit Amount")) ? "Total" : "";
        } else if (key == "Debit Amount") {
          acc[key] = selectedValues?.columns?.includes("Debit Amount") ? numberWithCommas(totalDebit) : "";
        } else if (key == "Credit Amount") {
          acc[key] = selectedValues?.columns?.includes("Credit Amount") ? numberWithCommas(totalCredit) : "";
        } else {
          acc[key] = '';
        }
        return acc;
      }, {});
      // push kr dia array ma object new wala
      ArrayData.push(summaryRow);
    }

    generateExcel(
      "Payment Register Report",
      "Payment Register Report",
      "File",
      "File",
      "DCCL",
      headings,
      reorderedColumns,
      ArrayData,
      [],
      []
    );
    setLoadingFileDownload(false)
  };

  const handleTXT = () => {
    const dataSequence = allData?.slice(0, itemsToShow)?.map((item) => {
      return {
        Ledger_ID: item?._id,
        Txn_Type: CapTxnType(item?.txnr_type),
        Description: item.description.split("-")[0],
        Instruction_Date: item?.instruction_date
          ? moment(item.instruction_date).format("DD-MM-YYYY")
          : "-",
        Instrument_Date: item?.instrument_date
          ? moment(item.instrument_date).format("DD-MM-YYYY")
          : "-",
        Instrument_No: item.instrument_no || "-",
        Instrument_Type: item.instrument_type || "-",
        Bank_Branch: `${item.bank_code || ""}-${item.branch || ""}`,
        Account_Number: item.account_number || "-",
        Credit_Amount: numberWithCommas(item.credit_amount),
        Net_Amount: numberWithCommas(item.debit_amount),
        Realized: item.realized === "true" || item.realized === true
          ? "true"
          : "false",
      }
    })

    dataSequence.push({
      Ledger_ID: selectedValues?.columns?.includes("Credit Amount") || selectedValues?.columns?.includes("Debit Amount") ? "Total" : "",
      Txn_Type: "",
      Description: "",
      Instruction_Date: "",
      Instrument_Date: "",
      Instrument_No: "",
      Instrument_Type: "",
      Bank_Branch: "",
      Account_Number: "",
      Credit_Amount: selectedValues?.columns?.includes("Credit Amount") && numberWithCommas(totalCredit),
      Net_Amount: selectedValues?.columns?.includes("Debit Amount") && numberWithCommas(totalDebit),
      Realized: "",
    })

    const reorderColumns = (columns, order) => {
      return order.filter(column => columns.includes(column));
    };

    const reorderedColumns = reorderColumns(selectedValues?.columns, fixedOrder);

    const ArrayData = selectedValues?.columns?.length > 0 && dataSequence?.map(entry => {
      const result = {};
      reorderedColumns.forEach(column => {
        if (column === 'Ledger ID') {
          result[column] = entry?.Ledger_ID;
        }
        else if (column === 'Txn Type') {
          result[column] = entry?.Txn_Type;
        }
        else if (column === 'Description') {
          result[column] = entry?.Description;
        }
        else if (column === 'Instruction Date') {
          result[column] = entry?.Instruction_Date;
        }
        else if (column === 'Instrument Date') {
          result[column] = entry?.Instrument_Date;
        }
        else if (column === 'Instrument No') {
          result[column] = entry?.Instrument_No;
        }
        else if (column === 'Instrument Type') {
          result[column] = entry?.Instrument_Type;
        }
        else if (column === 'Bank/Branch') {
          result[column] = entry?.Bank_Branch;
        }
        else if (column === 'Account Number') {
          result[column] = entry?.Account_Number;
        }
        else if (column === 'Credit Amount') {
          result[column] = numberWithCommas(entry?.Credit_Amount);
        }
        else if (column === 'Debit Amount') {
          result[column] = numberWithCommas(entry?.Net_Amount);
        }
        else if (column === 'Realized') {
          result[column] = entry?.Realized;
        }
      });
      return result;

    });


    let formattedContent = `${selectedValues?.heading ? selectedValues?.heading : ""},,,\n`;
    formattedContent += `${selectedValues?.sub_heading ? selectedValues?.sub_heading : ""},,,\n`;
    formattedContent += `"Fund:","${resFundName}",`;
    formattedContent += `"From Date:","${moment(resFromDate).format("DD-MM-YYYY")}",,\n`;
    formattedContent += `"To Date:","${moment(resToDate).format("DD-MM-YYYY")}",`;
    formattedContent += `"Report Date:","${moment(date).format("DD-MM-YYYY")}",,\n`;

    exportToTxt(formattedContent, selectedValues, ArrayData, "Payment Register Report")
  }

  const handleShowMore = () => {
    setItemsToShow(prev => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = resPaymentType + "-Register-Report.pdf"
    const options = {
      filename: fileName,
      margin: [10, 3, 10, 3],
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: { unit: 'mm', format: paperSizeVal || "A4", orientation: layoutVal === "Landscape" ? 'landscape' : "portrait" },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  let debitVal = 0
  let creditVal = 0

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      Receipt/Payment Register Report
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFund}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFundName(e?.label);
                              setFundCode(e?.value);
                              setAllDataCount(0)
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setFundName(
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                    .text
                              );
                              setFundCode(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group">
                          <label>Select Payment Type</label>
                          <Select
                            value={selectedPayment}
                            label={"Select Payment Type"}
                            onChange={(e) => {
                              setPaymentType(e?.value);
                              setAllDataCount(0)
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={paymentTypeArr}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setPaymentType(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Payment Type
                            </option>
                            <option value="Receipt">Receipt</option>
                            <option value="Payment">Payment</option>
                          </select> */}
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group">
                          <label>Select Type</label>
                          <Select
                            value={selectedType}
                            label={"Select Type"}
                            onChange={(e) => {
                              setType(e?.value);
                              setAllDataCount(0)
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={typeArr}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setType(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Type
                            </option>
                            <option value="false">Posting</option>
                            <option value="true">Realized</option>
                          </select> */}
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="form-group  ">
                          <label>Settlement Date From</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={fromDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setFromDate(date);
                              setAllDataCount(0)
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="2">
                        <div className="form-group  ">
                          <label>Settlement Date To</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            defaultValue={toDate}
                            className="form-control py-1"
                            onChange={(e) => {
                              let date = moment(e.target.value).format(
                                "YYYY-MM-DD"
                              );
                              setToDate(date);
                              setAllDataCount(0)
                              setItemsPerPage(10)
                              setItemsToShow(10)
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="2">
                        <div className="mt-1">
                          {/* here Search Button */}
                          <button
                            style={{
                              paddingTop: "8px",
                              paddingBottom: "8px",
                            }}
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              searchData();
                            }}
                            disabled={Boolean(loading)}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Loading...</span>
                              </>
                            ) : (
                              <span>Search</span>
                            )}
                          </button>
                        </div>
                      </Col>
                    </Row>
                    {/* End */}
                  </div>
                </div>

                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {allData.length > 0 && <Row>
                      <ReportTemplates
                        ColumnArr={ColumnArr}
                        selectedValues={selectedValues}
                        setSelectedValues={setSelectedValues}
                        pdfExportComponent={pdfExportComponent}
                        setFontSizeVal={setFontSizeVal}
                        fontSizeVal={fontSizeVal}
                        setPaperSizeVal={setPaperSizeVal}
                        paperSizeVal={paperSizeVal}
                        setLayoutVal={setLayoutVal}
                        layoutVal={layoutVal}
                        setScalePDF={setScalePDF}
                        scalePDF={scalePDF}
                        setMarginPDF={setMarginPDF}
                        marginPDF={marginPDF}
                        setScreenSizePerPdf={setScreenSizePerPdf}
                        screenSizePerPdf={screenSizePerPdf}
                        setDimensionOfPages={setDimensionOfPages}
                        contentRef={contentRef}
                        fileName={resPaymentType + "-Register-Report-" + date + ".pdf"}
                        printExcel={handleDownloadSampleFile}
                        printTXT={handleTXT}
                        printpdf={handleGeneratePdf}
                      />
                    </Row>}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-4"
                      style={{
                        // background: "white",
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width:
                            `${dimensionOfPages?.find((item) => item?.key == paperSizeVal)?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                            }`,
                          height: 'auto',
                          margin: '0 auto',
                          backgroundColor: "white"
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize="A4"
                          margin="1.5cm"
                          scale={0.6}
                          repeatHeaders={true}
                          fileName={
                            resPaymentType + "-Register-Report-" + date + ".pdf"
                          }
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in"
                            }}
                            ref={contentRef}>
                            {allDataCount > 0 ? (
                              <>
                                <ReportHeader
                                  title={resPaymentType + " Register Report"}
                                />
                                <Row>
                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Fund:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {resFundName}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          From Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {moment(resFromDate).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          To Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {moment(resToDate).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>

                                  <Col md="4" style={{ marginLeft: "70px" }}>
                                    <Row>
                                      <Col md="5">
                                        <span id="test"
                                          className="ReportTopStyling"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          Report Date:
                                        </span>
                                      </Col>
                                      <Col md="6">
                                        <span id="test" className="ReportTopStyling">
                                          {moment(date).format("DD-MM-YYYY")}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>

                                {selectedValues?.columns?.length > 0 ?
                                  <div
                                    style={{
                                      overflowX: "auto",
                                      overflowY: "hidden",
                                    }}
                                  >
                                    <table
                                      className="report"
                                      style={{ color: "black" }}
                                    >
                                      <thead style={{ alignSelf: "center" }}>
                                        <tr>

                                          {selectedValues?.columns?.includes("Ledger ID") && <th className="htmltoPdfStyle" id="test">Ledger ID</th>}
                                          {selectedValues?.columns?.includes("Txn Type") && <th className="htmltoPdfStyle" id="test">Txn Type</th>}
                                          {selectedValues?.columns?.includes("Description") && <th className="htmltoPdfStyle" id="test">Description</th>}
                                          {selectedValues?.columns?.includes("Instruction Date") && <th className="htmltoPdfStyle" id="test">Instruction Date</th>}
                                          {selectedValues?.columns?.includes("Instrument Date") && <th className="htmltoPdfStyle" id="test">Instrument Date</th>}
                                          {selectedValues?.columns?.includes("Instrument No") && <th className="htmltoPdfStyle" id="test">Instrument No</th>}
                                          {selectedValues?.columns?.includes("Instrument Type") && <th className="htmltoPdfStyle" id="test">Instrument Type</th>}
                                          {selectedValues?.columns?.includes("Bank/Branch") && <th className="htmltoPdfStyle" id="test">Bank/Branch</th>}
                                          {selectedValues?.columns?.includes("Account Number") && <th className="htmltoPdfStyle" id="test">Account Number</th>}
                                          {selectedValues?.columns?.includes("Credit Amount") && <th className="htmltoPdfStyle" id="test">Credit Amount</th>}
                                          {selectedValues?.columns?.includes("Debit Amount") && <th className="htmltoPdfStyle" id="test">Debit Amount</th>}
                                          {selectedValues?.columns?.includes("Realized") && <th className="htmltoPdfStyle" id="test">Realized</th>}
                                        </tr>
                                      </thead>
                                      <tbody className="report-table-body">
                                        {allData?.slice(0, itemsToShow).map((item: any, index: number) => {

                                          return (
                                            <>
                                              <tr key={index}>
                                                {selectedValues?.columns?.includes("Ledger ID") && (
                                                  <td className="htmltoPdfStyle" id="test">
                                                    {/* {item?.legder_id?.split("_")[1]} */}
                                                    {item?._id?.split("_")[1]}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Txn Type") && (
                                                  <td className="htmltoPdfStyle" id="test">{CapTxnType(item?.txnr_type)}</td>
                                                )}
                                                {selectedValues?.columns?.includes("Description") && (
                                                  <td className="htmltoPdfStyle" id="test">
                                                    {item.description.split("-")[0]}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Instruction Date") && (
                                                  <td className="htmltoPdfStyle" id="test">
                                                    {item?.instruction_date
                                                      ? moment(item.instruction_date).format("DD-MM-YYYY")
                                                      : "-"}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Instrument Date") && (
                                                  <td className="htmltoPdfStyle" id="test">
                                                    {item?.instruction_date
                                                      ? moment(
                                                        item.instruction_date
                                                      ).format("DD-MM-YYYY")
                                                      : "-"}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Instrument No") && (
                                                  <td className="htmltoPdfStyle" id="test">{item.instrument_no || "-"}</td>
                                                )}
                                                {selectedValues?.columns?.includes("Instrument Type") && (
                                                  <td className="htmltoPdfStyle" id="test">{item.instrument_type || "-"}</td>
                                                )}
                                                {selectedValues?.columns?.includes("Bank/Branch") && (
                                                  <td className="htmltoPdfStyle" id="test">
                                                    {item.bank_code || ""}-
                                                    {item.branch || ""}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Account Number") && (
                                                  <td className="htmltoPdfStyle" id="test">{item.account_number || "-"}</td>
                                                )}
                                                {selectedValues?.columns?.includes("Credit Amount") && (
                                                  <td id="test" className="text-right htmltoPdfStyle">
                                                    {numberWithCommas(
                                                      item.credit_amount
                                                    )}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Debit Amount") && (
                                                  <td id="test" className="text-right htmltoPdfStyle">
                                                    {numberWithCommas(
                                                      item.debit_amount
                                                    )}
                                                  </td>
                                                )}
                                                {selectedValues?.columns?.includes("Realized") && (
                                                  <td >
                                                    <input
                                                      type="checkbox"
                                                      className="ml-2"
                                                      readOnly
                                                      checked={
                                                        item.realized === "true" ||
                                                          item.realized === true
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  </td>
                                                )}
                                              </tr>

                                            </>
                                          );
                                        })}
                                        <tr>
                                          {selectedValues?.columns?.filter((ele) => ele == "Ledger ID" || ele == "Txn Type" || ele == "Description" || ele == "Instruction Date" || ele == "Instrument Date" || ele == "Instrument No" || ele == "Instrument Type" || ele == "Bank/Branch" || ele == "Account Number")?.length > 0 &&
                                            <th className="htmltoPdfStyle" id="test" colSpan={
                                              (selectedValues?.columns?.includes("Credit Amount") && selectedValues?.columns?.includes("Debit Amount")) ?
                                                (selectedValues?.columns?.includes("Realized") ? selectedValues?.columns?.length - 3 : selectedValues?.columns?.length - 2) : (selectedValues?.columns?.length - 2)}>Total</th>
                                          }
                                          {selectedValues?.columns?.includes("Credit Amount") && <th id="test" className="text-right htmltoPdfStyle">
                                            {numberWithCommas(totalCredit)}
                                          </th>}
                                          {selectedValues?.columns?.includes("Debit Amount") && <th id="test" className="text-right htmltoPdfStyle">
                                            {numberWithCommas(totalDebit)}
                                          </th>}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  :
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                }
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        {allData?.length >= 10 && selectedValues?.columns?.length > 0 && allDataCount > 0 && <UncontrolledDropdown
                          className="me-2 mt-2"
                          direction="down"
                        >
                          <DropdownToggle
                            id="TotalRecord_dropdown"
                            style={{
                              background: "none",
                              padding: "0px",
                              margin: "0px"
                            }}
                            className="border"
                          // style={{
                          //   borderRadius: "4px",
                          //   color: theme == "light" ? "black" : "",
                          // }}
                          // caret
                          // size="sm"
                          >
                            <div
                              id="report_dropdown"
                              style={{
                                borderRadius: "4px",
                                padding: "5px 15px",
                                color: theme == "light" ? "black" : "white",
                              }}
                            >
                              Per page :{" "}
                              {
                                itemsPerPage
                              }
                            </div>

                            {/* {selectedValues?.columns?.length > 0 &&
                                bankStatementDataCount > 0
                                ? bankStatement?.length
                                : 0} */}
                          </DropdownToggle>
                          <DropdownMenu
                            style={{
                              // width: "100%",
                              maxHeight: "300px",
                              overflow: "auto",
                              backgroundColor:
                                theme == "dark" ? "rgb(30, 30, 47)" : "",
                            }}
                          >
                            <DropdownItem
                              className={
                                itemsPerPage == 10 ? "bg-info text-white" : ""
                              }
                              onClick={() => {
                                setItemsPerPage(10);
                                setItemsToShow(10);
                              }}
                            >
                              10
                            </DropdownItem>
                            <DropdownItem
                              className={
                                itemsPerPage == 25 ? "bg-info text-white" : ""
                              }
                              onClick={() => {
                                setItemsPerPage(25);
                                setItemsToShow(25);
                              }}
                            >
                              25
                            </DropdownItem>
                            <DropdownItem
                              className={
                                itemsPerPage == 50 ? "bg-info text-white" : ""
                              }
                              onClick={() => {
                                setItemsPerPage(50);
                                setItemsToShow(50);
                              }}
                            >
                              50
                            </DropdownItem>
                            <DropdownItem
                              className={itemsPerPage == "All" ? "bg-info text-white" : ""}
                              onClick={() => {
                                setItemsPerPage("All")
                                setItemsToShow(allData?.length);
                              }}
                            >
                              All
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>}
                      </div>
                      <div
                        className="col-md-4"
                      >
                        {itemsToShow < allData?.length && selectedValues?.columns?.length > 0 && allDataCount > 0 && (
                          <div
                            className='d-flex justify-content-center my-2'
                          >
                            <button
                              className="btn btn-primary mt-3"
                              onClick={handleShowMore}
                            >
                              Show More
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        {allData?.length > 0 && selectedValues?.columns?.length > 0 && allDataCount > 0 && <div className="d-flex align-items-center justify-content-end">
                          <div
                            id="TotalRecord_dropdown"
                            className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                            style={{
                              borderRadius: "4px",
                              color: theme == "light" ? "black" : "white",
                              marginTop: "13px"
                            }}
                          >
                            Total record : {(selectedValues?.columns?.length > 0 && allDataCount > 0) ? allData?.length : 0}
                          </div>
                        </div>}
                      </div>
                    </div>

                    {/* <button
              className="btn btn-info mt-3"
              onClick={() => {
                var printContents = document.getElementById("printDiv")!.innerHTML;
                var originalContents = document.body.innerHTML;
           
                document.body.innerHTML = printContents;
           
                window.print();
           
                document.body.innerHTML = originalContents;

              }}
            >
              Print
            </button> */}
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default RecieptPaymentRegisterReport;
